<template>
  <UserInfo :user="user" />
</template>

<script setup lang="ts">
import { useUser } from '../../stores/userStore';
import UserInfo from './UserInfo.vue';

const { user } = useUser();
</script>
